import { FC } from "react";
import classNames from "classnames";
import { Image as DatoImage, ResponsiveImageType } from "react-datocms";

import { ILink } from "@types";

import { TranslatedLink } from "components/atoms/TranslatedLink/TranslatedLink";

import { ArticleTagRecord } from "@graphql/types/graphql";
import s from "./ImageTeaserHorizontal.module.scss";
import { StructuredText } from "components/sections/RichtextSection/StructuredText";

interface Props {
  link: ILink;
  image?: ResponsiveImageType;
  tag?: ArticleTagRecord;
  title: string;
  description: any;
  date: string;
  isHorizontal?: boolean;
  isHighlighted?: boolean;
}

export const ImageTeaserHorizontal: FC<Props> = ({
  link,
  image,
  tag,
  title,
  description,
  date,
  isHorizontal,
  isHighlighted,
}) => (
  <TranslatedLink
    link={link}
    className={classNames(s.Teaser, {
      [s.IsHighlighted]: isHighlighted,
      [s.IsHorizontal]: isHorizontal,
    })}
  >
    {image && (
      <div className={s.Image}>
        <DatoImage data={image} layout="responsive" />
      </div>
    )}
    <div className={s.Content}>
      {tag && <div className={s.Tag}>{tag.title}</div>}
      <h3 className={s.Title}>{title}</h3>
      {!isHighlighted && (
        <div className={classNames(s.Description, "prose")}>
          <StructuredText structuredText={description as any} />
        </div>
      )}
      <div className={s.Date}>{date}</div>
    </div>
  </TranslatedLink>
);
